export enum UpdateStrategy {
    Merge = 'merge',
    Override = 'override',
}

export enum ConfirmationEnum {
    Yes = 'yes',
    No = 'no',
}